export default class Sizes {
  constructor() {
    this.isPixelRatioOverride = false

    // Setup
    this.width = window.innerWidth
    this.height = window.innerHeight
    this.pixelRatio = Math.min(window.devicePixelRatio, 1.5)
    this.aspect = this.width / this.height
  }

  resize(_dom = false) {
    this.width = _dom ? _dom.clientWidth : window.innerWidth
    this.height = _dom ? _dom.clientHeight : window.innerHeight

    // console.log(this.width, this.height)

    if (!this.isPixelRatioOverride) {
      this.pixelRatio = Math.min(window.devicePixelRatio, 1.5)
    }
    this.aspect = this.width / this.height
  }
}
